import React from 'react';
import {
  Box,
  ChoiceBox,
  ChoiceboxGroup,
  Text,
} from '@sparknz/spark-pattern-library';

interface ChoiceBoxSelectorProps {
  items: { id: string; label: string; subLabel: string }[];
  selectedItem: string;
  setSelectedItem: (val: string) => void;
}

const ChoiceBoxSelector: React.FC<ChoiceBoxSelectorProps> = ({
  items,
  selectedItem,
  setSelectedItem,
}) => {
  return (
    <Box pt="s2" pb="s3">
      <ChoiceboxGroup>
        {items.map(({ id, label, subLabel }) => (
          <ChoiceBox
            key={id}
            name={id}
            value={selectedItem}
            checked={selectedItem === id}
            onChange={() => setSelectedItem(id)}
          >
            <div>
              <Text variant="bodySDemi">{label}</Text>
              <Text variant="bodySMedium">{subLabel}</Text>
            </div>
          </ChoiceBox>
        ))}
      </ChoiceboxGroup>
    </Box>
  );
};

export default ChoiceBoxSelector;
